import React from "react";
import "./MeasuringInstrument.scss";
import TitleFormat2 from "../../../components/TitleFormat2";
import { useTranslation } from "react-i18next";
import { Seo } from "../../../components/Seo";

const MeasuringInstrument = () => {
  const { t } = useTranslation();
  const contents = t("trackRecord.measuring.content", { returnObjects: true }) as { path: string; company: string; model: string }[];

  return (
    <>
      <Seo title={t("trackRecord.measuring.seo.title")} description={t("trackRecord.measuring.seo.des")} path="projects/equipment" />
      <TitleFormat2 text={t("trackRecord.measuring.title")} />
      <div className="measuringInstrument_wrap">
        <table>
          <thead>
            <tr>
              <th className="col_1">No.</th>
              <th className="col_2">{t("trackRecord.measuring.table.header.image")}</th>
              <th className="col_3">{t("trackRecord.measuring.table.header.company")}</th>
              <th className="col_4">{t("trackRecord.measuring.table.header.model")}</th>
            </tr>
          </thead>
          <tbody>
            {contents.map((data: { path: string; company: string; model: string }, index: number) => {
              return (
                <tr key={`${data.path}_${index}`}>
                  <td className="col_1">{index + 1}</td>
                  <td className="col_2">
                    <div className="img_box">
                      <img src={data.path} alt={data.model} />
                    </div>
                  </td>
                  <td className="col_3">{data.company}</td>
                  <td className="col_4">{data.model}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default MeasuringInstrument;
